import { Button, Icon } from '@britishcouncil/react-admin';
import styled from '@emotion/styled';
import { Modal } from 'semantic-ui-react';
import { Link, generatePath, useLocation } from 'react-router';
import { ROUTING_PATHS } from 'const';
import { useIntParam } from 'hooks';

type Props = {
  isSubmitting: boolean;
  submitted: boolean;
  submitText: string;
  onSubmit?: () => void;
  disabled?: boolean;
  onCreateNewSpeakingSession?: () => void;
};

export const Footer = ({
  isSubmitting,
  submitted,
  submitText,
  onSubmit,
  disabled,
  onCreateNewSpeakingSession,
}: Props) => {
  const { lrwSessionDetails } = ROUTING_PATHS;
  const lrwSessionId = useIntParam('sessionId');
  const location = useLocation();

  return (
    <S.Actions>
      {onCreateNewSpeakingSession && (
        <S.CreateNewSessionButton compact basic type="button" onClick={onCreateNewSpeakingSession}>
          <Icon name="plus square" />
          Create new Speaking session
        </S.CreateNewSessionButton>
      )}
      <Link
        to={generatePath(lrwSessionDetails.absolutePath, { sessionId: lrwSessionId })}
        state={location.state}
      >
        <Button compact type="reset" secondary>
          Cancel
        </Button>
      </Link>

      <Button
        compact
        color="blue"
        type="submit"
        disabled={isSubmitting || submitted || disabled}
        loading={isSubmitting}
        onClick={onSubmit}
      >
        {submitText}
      </Button>
    </S.Actions>
  );
};

const S = {
  Actions: styled(Modal.Actions)`
    display: flex;
    justify-content: flex-end;
  `,
  CreateNewSessionButton: styled(Button)`
    margin-right: auto !important;
  `,
};
